<template>
	<div class="production-barcode-reader" v-if="production != null">
		<CRow class="my-3" alignHorizontal="center" alignVertical="center">
			<CCol col="4" class="text-right">
				<h5 v-if="mode === 'scan'" class="mb-0 scan">Ajouter un colis</h5>
				<h5 v-if="mode === 'unscan'" class="mb-0 unscan">Retirer un colis</h5>
			</CCol>
			<CCol col="5">
				<input
					v-model="scanPackage"
					ref="packageInput"
					type="text"
					placeholder="Entrez une référence"
					class="form-control"
					autofocus
					:disabled="loading"
				/>
			</CCol>
			<CCol col="3" class="text-left">
				<CButton
					v-if="mode === 'unscan'"
					:class="{ 'ml-2': true, 'border-info': mode === 'scan' }"
					style="border-width: 3px !important"
					color="primary"
					v-on:click="mode = 'scan'"
					>Ajouter</CButton
				>
				<CButton
					v-if="mode === 'scan'"
					:class="{ 'ml-2': true, 'border-info': mode === 'unscan' }"
					style="border-width: 3px !important"
					color="primary"
					v-on:click="mode = 'unscan'"
					>Retirer</CButton
				>
			</CCol>
		</CRow>
	</div>
</template>

<script>
	import SuccessSound from '../../../../assets/sounds/confirm_sound.mp3';
	import ErrorSound from '../../../../assets/sounds/error_sound.mp3';
	import { debounce } from 'lodash';

	const successSound = new Audio(SuccessSound);
	const errorSound = new Audio(ErrorSound);

	successSound.crossOrigin = 'anonymous';
	errorSound.crossOrigin = 'anonymous';

	export default {
		props: {
			production: Object,
		},

		data() {
			return {
				modalOpen: false,
				scanPackage: null,
				loading: false,
				mode: 'scan',
				recentScans: new Set(),
				scanTimeout: 1500,
				debounceDelay: 50,
			};
		},

		created() {
			this.debouncedHandleScan = debounce(this.handleScan, this.debounceDelay);
		},

		mounted() {
			this.listenKeyboard();
		},

		watch: {
			scanPackage(newVal) {
				if (newVal && newVal.length >= 13) {
					this.debouncedHandleScan(newVal);
				}
			}
		},

		methods: {
			async handleScan(code) {
				const cleanCode = code.replace(/[^A-Za-z0-9]/g, '');

				if (!cleanCode || cleanCode.length < 13) {
					return;
				}

				if (this.recentScans.has(cleanCode)) {
					this.scanPackage = null;
					return;
				}

				this.recentScans.add(cleanCode);
				setTimeout(() => {
					this.recentScans.delete(cleanCode);
				}, this.scanTimeout);

				await this.newScan(cleanCode);
			},

			async newScan(code) {
				this.loading = true;

				try {
					await this.$axios.post(`${this.production['@id']}/${this.mode}`, {
						shippingNumber: code,
					});

					this.$toast.success(this.mode === 'scan' ? 'Colis ajouté' : 'Colis retiré');
					successSound.play();
				} catch (err) {
					console.error(err);
					this.$toast.error(err.response.data['hydra:description']);
					errorSound.play();
				} finally {
					this.loading = false;
					this.scanPackage = null;
					this.$nextTick(() => {
						this.$refs.packageInput?.focus();
					});
				}
			},

			listenKeyboard() {
				document.addEventListener('keydown', e => {
					if (!this.modalOpen) {
						this.$nextTick(() => {
							this.$refs?.packageInput?.focus();
						});
					}
				});
			},
		},

		beforeDestroy() {
			this.debouncedHandleScan.cancel();
		},
	};
</script>

<style scoped>
	.production-barcode-reader {
		position: fixed;
		bottom: 10px;
		right: 30px;
		background-color: white;
		border: 2px solid lightgray;
		border-radius: 5px;
		width: 40%;
	}

	h5.scan {
		color: green;
		font-weight: bold;
	}

	h5.unscan {
		color: red;
		font-weight: bold;
	}
</style>
